import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import ParentResult from "../../components/test-result-template/ParentResult";
import { useLocation } from "react-router-dom";

const PrintParentResult = (props: any) => {
  const location = useLocation();

  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Report.pdf`,
  });

  return (
    <div className="tw-bg-[#F7F6F4]">
      <div className=" tw-pl-[70%]">
        <button
          className="tw-text-white lg:tw-my-5 tw-text-[16px] tw-border-2 tw-px-[20px] tw-py-3 tw-border-reddishOrange tw-rounded-[10px] tw-bg-reddishOrange tw-cursor-pointer"
          onClick={handlePrint}
        >
          Print result
        </button>
      </div>
      <div>
        <ParentResult ref={componentRef} result={location.state} />
      </div>
    </div>
  );
};

export default PrintParentResult;
